import React from 'react'
import { Button } from '@mui/material'
const ReUseableButton = ({style, onclick, children}) => {
return(
    <Button style={style} onclick={onclick} > {children}</Button>
)
}

 export default  ReUseableButton